var appEnv;
var setEnv = function setEnv(env) {
  appEnv = env;
};
var getEnv = function getEnv() {
  return appEnv;
};

var Environments;

(function (Environments) {
  Environments["DEV"] = "dev";
  Environments["DEV_DIST"] = "devDist";
  Environments["PRODUCTION"] = "production";
  Environments["SANDBOX"] = "sandbox";
  Environments["TESTING"] = "testing";
  Environments["UNIT_TEST"] = "test";
})(Environments || (Environments = {}));

var TESTING$1 = Environments.TESTING,
    SANDBOX = Environments.SANDBOX,
    PRODUCTION = Environments.PRODUCTION,
    DEV = Environments.DEV;
function getEnvByHostname() {
  if (/cabify-testing.com/.test(window.location.hostname)) {
    return TESTING$1;
  }

  if (/cabify-sandbox.com/.test(window.location.hostname)) {
    return SANDBOX;
  }

  if (/cabify.com/.test(window.location.hostname)) {
    return PRODUCTION;
  }

  return DEV;
}

var TESTING = Environments.TESTING;
function getServerName() {
  var appEnv = getEnv();
  var environment = /(.*)\.cabify-testing.com/.exec(window.location.hostname);

  if (appEnv === TESTING && environment) {
    return "testing-".concat(environment[1]);
  }

  return window.serverEnv && window.serverEnv.environment || appEnv;
}

var isProduction = function isProduction() {
  var appEnv = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getEnv();
  return appEnv === Environments.PRODUCTION;
};

export { Environments, getEnv, getEnvByHostname, getServerName, isProduction, setEnv };
//# sourceMappingURL=index.js.map
